import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { toast } from './Toasts';

/** The asset's permanent ID with a copy button. */
export function AssetCode({ code, className = '' }: { code: string; className?: string }) {
  const [copied, setCopied] = useState(false);
  async function copy() {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast('Could not copy. Select the ID and copy it by hand.', 'error');
    }
  }
  return (
    <span className={`asset-code ${className}`} data-testid="asset-code">
      <span className="mono" title="Asset ID">{code}</span>
      <button type="button" className="btn ghost icon sm" aria-label={`Copy asset ID ${code}`} title="Copy asset ID" onClick={() => void copy()}>
        {copied ? <Check size={13} /> : <Copy size={13} />}
      </button>
    </span>
  );
}
